angular.module('tgaAdmin').controller('ActivityController', [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  'envService',
  'modalService',
  'localStorageService',
  'flashService',
  'activityService',
  '$translate',
  function (
    $scope,
    $state,
    $timeout,
    $filter,
    envService,
    modalService,
    localStorageService,
    flashService,
    activityService,
    $translate,
  ) {
    if (!envService.read('enableEvents')) {
      $state.go('v1.games');
    }

    $scope.data = {
      activityId: $state.params.id || null,
      activityTypes: [
        {
          key: 'image',
          name: 'Image',
        },
        {
          key: 'video',
          name: 'Video',
        },
        {
          key: 'link',
          name: 'Link',
        },
        {
          key: 'pdf',
          name: 'PDF',
        },
        {
          key: 'audio',
          name: 'Audio',
        },
      ],
    };

    $scope.viewmodel = {
      activity: {},
    };

    $scope.initialize = function () {
      if ($scope.data.activityId) {
        $scope.loading = true;
        activityService.getActivity($scope.data.activityId).then(
          (activity) => {
            // @TODO: use resolve to handle this
            $scope.title = `<span class="text-muted">Edit Activity /</span> ${activity.name}`;
            $scope.viewmodel.activity = activity;
            $scope.loading = false;
          },
          () => {
            // Invalid Activity ID
            $state.go('v1.games');
          },
        );
      }
    };

    $scope.actions = {
      submit() {
        $scope.submitted = true;

        if ($scope.timer) {
          $timeout.cancel($scope.timer);
        }
        $scope.data.alerts = [];

        $('.uib-tab').removeClass('has-error');

        if ($scope.activityForm.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );

          const field = $(':input.ng-invalid:visible:first');

          if (field.length) {
            $('html, body')
              .stop(true, false)
              .animate({ scrollTop: field.parent().offset().top - 110 }, 450);
          }

          $('.tab-pane').each(function (i) {
            if ($(this).find('.ng-invalid').length) {
              $('.uib-tab')
                .eq(i)
                .addClass('has-error');
            }
          });

          if (!field.length) {
            const panel = $('.panel-group .panel-danger:visible:first');

            if (panel.length) {
              $('html, body')
                .stop(true, false)
                .animate({ scrollTop: panel.offset().top - 120 }, 450);
            }
          }

          return;
        }

        $scope.processing = true;

        if ($scope.data.activityId) {
          // Editing activity
          activityService.updateActivity($scope.viewmodel.activity).then(
            (activity) => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> Activity updated successfully.', 'success');
              $scope.processing = false;
              $scope.title = `<span class="text-muted">Edit Activity /</span> ${activity.name}`;
              $scope.viewmodel.activity = activity;
            },
            (error) => {
              if (error.message) {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
              } else {
                $scope.actions.createAlert(
                  '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> There was an error processing your request.',
                  'danger',
                );
              }

              if (error.fields) {
                for (let i = 0; i < error.fields.length; i++) {
                  if ($scope.activityForm[error.fields[i]]) {
                    $scope.activityForm[error.fields[i]].$setValidity('required', false);
                  }
                }
              }

              $scope.processing = false;
            },
          );
        } else {
          // Adding new activity
          activityService.addActivity($scope.viewmodel.activity).then(
            (activity) => {
              flashService.set('<span class="fa fa-check"></span> Activity added successfully.', 'success');
              $scope.processing = false;
              $state.go('v1.editActivity', { id: activity.activity_id });
            },
            (error) => {
              if (error.message) {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
              } else {
                $scope.actions.createAlert(
                  '<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> There was an error processing your request.',
                  'danger',
                );
              }

              if (error.fields) {
                for (let i = 0; i < error.fields.length; i++) {
                  if ($scope.activityForm[error.fields[i]]) {
                    $scope.activityForm[error.fields[i]].$setValidity('required', false);
                  }
                }
              }

              $scope.processing = false;
            },
          );
        }
      },
      deleteActivity() {
        if ($scope.data.activityId) {
          modalService
            .showModal(
              {
                title: 'Delete Activity?',
                message:
                  // eslint-disable-next-line max-len
                  'Are you sure you want to delete this activity? All data associated with the activity will be permanently deleted including analytics.',
                closeButton: 'No',
                actionButton: 'Yes',
              },
              {
                backdrop: true,
                keyboard: true,
                animation: false,
              },
            )
            .then(
              () => {
                $scope.deleting = true;
                activityService.deleteActivity($scope.data.activityId).then(
                  () => {
                    flashService.set('<span class="fa fa-check"></span> Activity deleted successfully.', 'success');
                    $scope.deleting = false;
                    $state.go('v1.games');
                  },
                  (error) => {
                    $scope.actions.createAlert(
                      `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                      'danger',
                    );
                    $scope.deleting = false;
                  },
                );
              },
              () => {},
            );
        }
      },
      checkImage(image) {
        // console.log(image)
        $scope.data.alerts = [];

        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|pdf/i;
        if (!allowed.test(ext)) {
          image.base64 = null;
          // image.invalid_type = true;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 5MB.
        if (image.filesize > 5242880) {
          image.base64 = null;
          // image.invalid_size = true;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
            'danger',
          );
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });

        $scope.timer = $timeout(() => {
          $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
        }, 5000);
      },
    };

    $scope.initialize();
  },
]);
